<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">{{ i18nValues["labelAdmin"] }}</h4>
        <el-button v-if="componentsMap.get('labelBatch_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="generate()"
        >
          {{ i18nValues["generateLabels"] }}
        </el-button>
      </div>


      <!-- form -->
      <div class="grid-body no-border borderBottom">

        <el-form>
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by Dispatch Type -->
              <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType">
                <el-select
                  v-model="selectedDispatch"
                  :placeholder="i18nValues['dispatchType']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Product -->
              <el-form-item :label="i18nValues['brand-variety']" prop="product">
                <el-select
                  v-model="selectedVariety"
                  filterable
                  :placeholder="i18nValues['brand-variety']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="product in ProductList"
                      :key="product.id"
                      :label="`${product.brand} - ${product.name}`"
                      :value="product.name"
                  >
                  <span v-html="`<strong>${product.brand}</strong> - ${product.name}`"></span>
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Batch -->
              <el-form-item :label="i18nValues['batch']" prop="batch">
                <el-input
                  v-model="selectedBatch"
                  :placeholder="i18nValues['batch']"
                ></el-input>
              </el-form-item>

              <!-- search by Number -->
              <el-form-item :label="i18nValues['number']" prop="numberOfLabel">
                <el-input
                  v-model="selectedNumber"
                  :placeholder="i18nValues['number']"
                ></el-input>
              </el-form-item>

              <!-- search button  -->
              <el-button
                @click="retrieveLabelBatchsBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <el-form-item prop="labelBatch">
            <div class="full-width table-container" v-loading="loading" style="margin:0 auto;padding:20px;">
              <el-table
                :data="LabelBatchSublist"
                class="table table-hover"
                stripe
                id="LabelTable"
                align="center"
                :empty-text="hasAttemptedLoad ? i18nValues['noDataAvailable'] : ''"
                :default-sort="tableDefaultSort"
                @sort-change="handleSortChange"
              >
                <!-- LabelBatch LabelIdFrom -->
                <el-table-column
                  prop="labelIdFrom"
                  :label="i18nValues['labelIdFrom']"
                  width="55"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- LabelBatch labelIdTo -->
                <el-table-column
                  prop="labelIdTo"
                  :label="i18nValues['labelIdTo']"
                  width="48"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- LabelBatch qtyToPrint  -->
                <el-table-column
                  prop="qtyToPrint"
                  :label="i18nValues['quantity']"
                  width="42"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- LabelBatch -> Items -> Brand -->
                <el-table-column
                  prop="name"
                  label="Brand"
                  width="40"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- LabelBatch Batch  -->
                <el-table-column
                  prop="batch"
                  :label="i18nValues['batch']"
                  width="35"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- LabelBatch DispatchType -->
                <el-table-column
                  prop="dispatchType"
                  :label="i18nValues['shipment']"
                  width="42"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- State/Status -->
                <el-table-column
                  prop="state"
                  :label="i18nValues['status']"
                  width="38"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- LabelBatch Creation Date -->
                <el-table-column
                  prop="creationDate"
                  :label="i18nValues['created']"
                  width="40"
                  :formatter="formatCreationDate"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- LabelBatch Print Date -->
                <el-table-column
                  prop="printDate"
                  :label="i18nValues['printed']"
                  width="40"
                  :formatter="formatPrintDate"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- EDIT/DELETE -->
                <el-table-column width="50" align="right">
                  <template slot-scope="scope">
                    <el-button
                      v-if="isReadOnly()"
                      fixed="right"
                      class="text-info"
                      icon="fa fa-eye"
                      size="small"
                      :title="i18nValues['view']"
                      @click="edit(scope.row.id)"
                    ></el-button>
                    <el-button v-if="componentsMap.get('labelBatch_modification')"
                      class="text-info"
                      icon="fas fa-edit"
                      size="small"
                      :title="i18nValues['edit']"
                      @click="edit(scope.row.id)"
                    ></el-button>
                    <el-button
                      v-if="componentsMap.get('labelBatch_modifyBags')"
                      class="text-info"
                      icon="fas fa-boxes"
                      size="small"
                      :title="i18nValues['modifyBags'] || 'Modificar Bolsas'"
                      @click="openModifyBagsModal(scope.row)"
                    ></el-button>
                    <el-button
                      v-if="(scope.row.state === i18nValues['edition'] || scope.row.state === 'edition') && componentsMap.get('labelBatch_delete')"
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="deleteLabelBatch(scope.row.id)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="90 > 10" style="height: 15px"></div>
              <div class="pagination-bar">
                <PaginationFunctional
                  ref="pagination"
                  sublistName="LabelBatchSublist"
                  :fullList="LabelBatchList"
                  :tableSize="20"
                  :tableIndexInitial="initialPage"
                  @paginationChange="paginationChange"
                  @currentIndexPagination="setCurrentPage"
                  class="text-center"
                />
                <div v-if="LabelBatchList.length > 0" class="results-info">
                  <p>
                    {{ i18nValues['showing'] || 'Showing' }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues['of'] || 'of' }} {{ totalRecords }} {{ i18nValues['results'] || 'results' }}
                  </p>
                </div>
              </div>
            </div>
          </el-form-item>

        </el-form>

        <!-- Modify Bags Modal -->
        <LabelBagModificationModal
          :visible.sync="modifyBagsModalVisible"
          :labelBatchId="selectedLabelBatchIdForModify"
          @modified="onBagsModified"
        />

      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
import LabelBagModificationModal from "@/components/LabelBagModificationModal.vue";
//import moment from "moment";
export default {
  name: "LabelAdmin",
  created() {
    this.restoreFromQuery();
    this.retrieveProducts();
  },

  components: {
    PaginationFunctional,
    LabelBagModificationModal,
  },

  computed: {
    loading: get("label/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),

    options() {
      return [
        { value: "plane", label: this.i18nValues["aerial"] },
        { value: "ship", label: this.i18nValues["maritime"] },
      ];
    },

    // Pagination helpers for results label
    currentPage() {
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      return Array.isArray(this.LabelBatchList) ? this.LabelBatchList.length : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },
  },

  props:{
    componentsMap: {},
  },

  watch: {
    globalFieldSite: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        // Skip partial→full object update from TopBar
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.LabelBatchList = [];
        this.LabelBatchSublist = [];
        this.originalLabelBatchList = [];
        // Reset filters when fieldSite changes (not on first load)
        if (oldVal && oldVal.id) {
          this.selectedDispatch = null;
          this.selectedVariety = null;
          this.selectedBatch = null;
          this.selectedNumber = null;
          this.selectedLabelIdFrom = null;
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        this.fetchLabels(true);
        this.retrieveLabelBatchCount();
        this.syncRouteFromState();
      },
      immediate: true,
    },
    globalCampaign: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.LabelBatchList = [];
        this.LabelBatchSublist = [];
        this.originalLabelBatchList = [];
        // Reset filters when campaign changes (not on first load)
        if (oldVal && oldVal.id) {
          this.selectedDispatch = null;
          this.selectedVariety = null;
          this.selectedBatch = null;
          this.selectedNumber = null;
          this.selectedLabelIdFrom = null;
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        if (this.globalFieldSite && this.globalFieldSite.id) {
          this.fetchLabels(true);
          this.retrieveLabelBatchCount();
        }
        this.retrieveProducts();
        this.syncRouteFromState();
      },
      immediate: true,
    },
    i18nValues: {
      handler() {
        // Re-translate if language changes
      },
      deep: true,
    },
  },

  data() {
    const q = (this.$route && this.$route.query) || {};
    const normalizeSelect = (value, allowNumbers = false) => {
      if (value === undefined || value === null) {
        return null;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed === "" ? null : trimmed;
      }
      if (allowNumbers && typeof value === "number") {
        return Number.isNaN(value) ? null : value;
      }
      return value;
    };
    const normalizeText = (value) => {
      if (value === undefined || value === null) {
        return null;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed === "" ? null : trimmed;
      }
      return value;
    };
    return {
      selectedDispatch: normalizeSelect(q.dispatchType || null),
      selectedVariety: normalizeSelect(q.variety || null),
      selectedBatch: normalizeText(q.batch || null),
      selectedNumber: normalizeText(q.number || null),
      selectedLabelIdFrom: normalizeSelect(q.labelIdFrom || null, true),

      filter: {},

      filterList: [],

      LabelBatchList: [],
      LabelBatchSublist: [],
      originalLabelBatchList: [],
      cantidad: 100,
      ProductList: [],

      // options: [
      //   { value: "plane", label: "Aéreo" },
      //   { value: "ship", label: "Marítimo" },
      // ],

      variedades: [
        { value: "corn", label: "Corn Seed" },
        { value: "soy", label: "Soybean Production" },
        { value: "soyRD", label: "Soybean R&D" },
      ],

      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,
      hasAttemptedLoad: false,
      modifyBagsModalVisible: false,
      selectedLabelBatchIdForModify: null,

    };
  },

  methods: {
    // ── Central fetch — called by watchers, search button, and delete ──
    fetchLabels(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      this.hasAttemptedLoad = true;
      var gen = ++this.requestGeneration;

      // Determine if there are active filters
      var hasFilters = !!(this.selectedDispatch || this.selectedVariety ||
        this.selectedBatch || this.selectedNumber || this.selectedLabelIdFrom);

      var promise;
      if (hasFilters) {
        var payload = this.buildSearchFilterPayload();
        promise = this.$store.dispatch("label/retrieveLabelBatchsBySearch", payload);
      } else {
        var basePayload = this.buildBaseLabelFilter();
        this.filter = Object.assign({}, basePayload);
        promise = this.$store.dispatch("label/retrieveLabelBatchs", basePayload);
      }

      promise.then((res) => {
        // ── Stale-response guard ──
        if (gen !== this.requestGeneration) return;

        var preparedList = this.prepareLabelBatchList(res);
        this.originalLabelBatchList = preparedList;

        // Apply sorting
        var nextList;
        if (!this.sortProp || !this.sortOrder) {
          nextList = [].concat(preparedList);
        } else {
          var helperSorted = this.sortUsingHelper(preparedList, this.sortProp, this.sortOrder);
          nextList = Array.isArray(helperSorted) ? helperSorted : this.sortListLocally(preparedList, this.sortProp, this.sortOrder);
        }
        this.LabelBatchList = nextList;

        if (!preservePage) {
          this.initialPage = 1;
        }

        this.syncRouteFromState();

        // Sync pagination
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            var targetPage = preservePage ? (this.initialPage || 1) : 1;
            this.$refs.pagination.currentChange(targetPage);
          }
        });
      });
    },

    // Aliases — existing callers (template @click, etc.) keep working
    retrieveLabelBatchsBySearch() {
      this.fetchLabels(false);
    },
    retrieveLabelBatchs() {
      this.fetchLabels(true);
    },

    prepareLabelBatchList(rawList) {
      if (!Array.isArray(rawList)) {
        return [];
      }
      const seen = new Set();
      const prepared = [];
      rawList.forEach((item) => {
        if (!item) {
          return;
        }
        const key = this.buildLabelBatchKey(item);
        if (seen.has(key)) {
          return;
        }
        seen.add(key);
        this.decorateLabelBatch(item);
        prepared.push(item);
      });
      return prepared;
    },

    buildLabelBatchKey(item) {
      const id = item && item.id ? item.id : "null";
      const dispatchType =
        item && item.dispatchType ? item.dispatchType : "null";
      const name = item && item.name ? item.name : "null";
      const batch = item && item.batch ? item.batch : "null";
      return `${id}|${dispatchType}|${name}|${batch}`;
    },

    decorateLabelBatch(item) {
      this.translate(item);
      if (Array.isArray(item.items)) {
        item.items.forEach((nested) => {
          const brand =
            nested && nested.product && nested.product.brand
              ? nested.product.brand
              : null;
          const batchValue = nested && nested.batch ? nested.batch : null;
          if (brand) {
            item.name = item.name ? `${item.name},${brand}` : brand;
          }
          if (batchValue) {
            item.batch = item.batch ? `${item.batch},${batchValue}` : batchValue;
          }
        });
      }
    },

    sortUsingHelper(list, prop, order) {
      // For 'batch', always fall back to local sort to use label-specific semantics
      if (prop === "batch") {
        return null;
      }
      if (
        this.$refs &&
        this.$refs.pagination &&
        typeof this.$refs.pagination.handleSortChangePagination === "function"
      ) {
        return this.$refs.pagination.handleSortChangePagination(
          { prop, order },
          list
        );
      }
      return null;
    },

    sortListLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return Array.isArray(list) ? [...list] : [];
      }
      const direction = order === "descending" ? -1 : 1;
      return [...list].sort((a, b) => {
        const aVal = this.getValueByPath(a, prop);
        const bVal = this.getValueByPath(b, prop);

        // Special handling for 'batch' column: prioritize single-batch entries,
        // and group multi-batch entries (values with commas) together,
        // while still sorting numerically by the first batch where possible.
        if (prop === "batch") {
          return this.sortBatchValues(aVal, bVal, direction);
        }

        if (this.isEmptyValue(aVal) && this.isEmptyValue(bVal)) {
          return 0;
        }
        if (this.isEmptyValue(aVal)) {
          return 1;
        }
        if (this.isEmptyValue(bVal)) {
          return -1;
        }
        if (this.isNumericValue(aVal) && this.isNumericValue(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        const comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
        });
        return comparison * direction;
      });
    },

    sortBatchValues(aVal, bVal, direction) {
      const aStr = (aVal == null ? "" : String(aVal)).trim();
      const bStr = (bVal == null ? "" : String(bVal)).trim();

      const aHasComma = aStr.includes(",");
      const bHasComma = bStr.includes(",");

      // Empty handling (reuse generic semantics)
      if (this.isEmptyValue(aStr) && this.isEmptyValue(bStr)) return 0;
      if (this.isEmptyValue(aStr)) return 1;
      if (this.isEmptyValue(bStr)) return -1;

      // Separate single vs multi:
      // Siempre agrupamos los multi-batch al final,
      // tanto en orden ascendente como descendente.
      if (aHasComma !== bHasComma) {
        // aHasComma === true  -> a (multi) va después de b (single)
        // aHasComma === false -> a (single) va antes de b (multi)
        return aHasComma ? 1 : -1;
      }

      // From here both are either single or both multi.
      // Compare by the first batch value (before the first comma).
      const aFirst = aStr.split(",")[0].trim();
      const bFirst = bStr.split(",")[0].trim();

      const aNum = Number(aFirst);
      const bNum = Number(bFirst);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return (aNum - bNum) * direction;
      }

      const cmp = aFirst.localeCompare(bFirst, undefined, { sensitivity: "base" });
      return cmp * direction;
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    syncPagination(targetIndex) {
      this.$nextTick(() => {
        if (
          this.$refs &&
          this.$refs.pagination &&
          typeof this.$refs.pagination.currentChange === "function"
        ) {
          const idx =
            typeof targetIndex === "number" && targetIndex > 0
              ? targetIndex
              : this.$refs.pagination.tableIndex || this.initialPage || 1;
          this.$refs.pagination.currentChange(idx);
        } else {
          this.LabelBatchSublist = Array.isArray(this.LabelBatchList)
            ? this.LabelBatchList.slice(0, this.pageSize)
            : [];
        }
      });
    },

    generate() {
      this.$router.push({
        name: `LabelEdition`,
        params: { id: "0" },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `LabelEdition`,
        params: { id: id },
        query: this.$route.query,
      });
    },

    deleteLabelBatch(id) {
      this.$confirm('Está seguro que quiere eliminar la etiqueta?', 'Eliminar Etiqueta', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        }).then(() => {
            this.$store.dispatch("label/deleteLabelBatch", id).then((res) => {
            if (res.status == "OK") {
              this.$notify.success({
                title: this.i18nValues["success"],
                message: "Se Elimino correctamente",
                position: "bottom-right",
              });
              this.fetchLabels(true);
              this.retrieveLabelBatchCount();
            } else {
              this.$notify.error({
                title: this.i18nValues["error"],
                message: "No se pudo eliminar",
                position: "bottom-right",
              });
            }
          });
        })
    },

    // print(labelBatch) {
    //   this.printing = true;
    //   this.$store.dispatch("label/downloadPDF", labelBatch.id).then((res) => {
    //     if (res.size == 0) {
    //       this.$notify.error({
    //         title: this.i18nValues["error"],
    //         message: this.i18nValues["errorDownload"],
    //         position: "bottom-right",
    //         duration: 7000,
    //       });
    //     } else {
    //       var blob = new Blob([res], { type: "application/pdf" });
    //       const links = document.createElement("a");
    //       links.href = URL.createObjectURL(blob);
    //       var date = moment().format("YYYYMMDDTHHmmss")
    //       links.download = "Placard_" + labelBatch.id.toString() + "_" + date;
    //       links.click();
    //       URL.revokeObjectURL(links.href);
    //     }
    //     this.printing = false;
    //   });
    // },

    translate(item){
      if(item.dispatchType == "plane"){
        item.dispatchType = this.i18nValues['aerial'];
      }    
      if(item.dispatchType == "ship"){
        item.dispatchType = this.i18nValues['maritime'];
      }
      if(item.state == "edition"){
        item.state = this.i18nValues['edition'];
      }
      if(item.state == "printed"){
        item.state = this.i18nValues['printed'];
      }
    },

    formatCreationDate(row) {
      return this.formatDate(row.creationDate);
    },    
    formatPrintDate(row) {
      return this.formatDate(row.printDate);
    },    

    retrieveProducts() {
      this.filter = {};
      this.filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
        this.$store.dispatch("product/retrieveProducts", this.filter).then((res) => {
          this.ProductList = res;
        });
      },

    retrieveLabelBatchCount() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) {
        this.cantidad = 0;
        return;
      }
      var gen = this.requestGeneration;
      const filter = this.buildBaseLabelFilter();
      this.$store
        .dispatch("label/countLabelBatchs", filter)
        .then((res) => {
          if (gen !== this.requestGeneration) return;
          this.cantidad = res;
        });
    },

    buildBaseLabelFilter(overrides = {}) {
      const payload = {
        fieldSiteId:
          this.globalFieldSite && this.globalFieldSite.id
            ? this.globalFieldSite.id
            : null,
        campaignId:
          this.globalCampaign && this.globalCampaign.id
            ? this.globalCampaign.id
            : null,
      };
      return Object.assign({}, this.removeEmptyFields(payload), overrides || {});
    },

    buildSearchFilterPayload(overrides = {}) {
      const searchPayload = {
        dispatchType: this.normalizeSelectValue(this.selectedDispatch),
        name: this.normalizeSelectValue(this.selectedVariety),
        batch: this.normalizeTextValue(this.selectedBatch),
        number: this.normalizeTextValue(this.selectedNumber),
        labelIdFrom: this.normalizeSelectValue(this.selectedLabelIdFrom, true),
      };
      const base = this.buildBaseLabelFilter(searchPayload);
      const merged = Object.assign({}, base, overrides || {});
      return this.removeEmptyFields(merged);
    },

    normalizeSelectValue(value, allowNumbers = false) {
      if (value === undefined || value === null) {
        return null;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed === "" ? null : trimmed;
      }
      if (allowNumbers && typeof value === "number") {
        return Number.isNaN(value) ? null : value;
      }
      return value;
    },

    normalizeTextValue(value) {
      if (value === undefined || value === null) {
        return null;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed === "" ? null : trimmed;
      }
      return value;
    },

    removeEmptyFields(payload) {
      const cleaned = {};
      Object.keys(payload || {}).forEach((key) => {
        const value = payload[key];
        if (value !== undefined && value !== null && value !== "") {
          cleaned[key] = value;
        }
      });
      return cleaned;
    },

    handleSortChange(event) {
      var nextProp = event && event.prop ? event.prop : null;
      var nextOrder = event && event.order ? event.order : null;
      var sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) return;

      // Re-sort from original list
      var baseList = Array.isArray(this.originalLabelBatchList) ? this.originalLabelBatchList : [];
      var nextList;
      if (!this.sortProp || !this.sortOrder) {
        nextList = [].concat(baseList);
      } else {
        var helperSorted = this.sortUsingHelper(baseList, this.sortProp, this.sortOrder);
        nextList = Array.isArray(helperSorted) ? helperSorted : this.sortListLocally(baseList, this.sortProp, this.sortOrder);
      }
      this.LabelBatchList = nextList;

      var currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex : this.initialPage || 1;
      this.initialPage = currentPage;
      this.syncRouteFromState();
      this.$nextTick(() => {
        if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
          this.$refs.pagination.currentChange(currentPage);
        }
      });
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.LabelBatchSublist = evt.list;
      }
      var currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex : this.initialPage;
      this.initialPage = currentIdx || 1;
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      var q = this.$route.query || {};
      this.selectedDispatch = this.normalizeSelectValue(q.dispatchType || null);
      this.selectedVariety = this.normalizeSelectValue(q.variety || null);
      this.selectedBatch = this.normalizeTextValue(q.batch || null);
      this.selectedNumber = this.normalizeTextValue(q.number || null);
      this.selectedLabelIdFrom = this.normalizeSelectValue(q.labelIdFrom || null, true);
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    openModifyBagsModal(row) {
      this.selectedLabelBatchIdForModify = row.id;
      this.modifyBagsModalVisible = true;
    },

    onBagsModified() {
      this.fetchLabels(true);
      this.retrieveLabelBatchCount();
    },

    syncRouteFromState() {
      var q = {};
      var dispatchType = this.normalizeSelectValue(this.selectedDispatch);
      var variety = this.normalizeSelectValue(this.selectedVariety);
      var batch = this.normalizeTextValue(this.selectedBatch);
      var number = this.normalizeTextValue(this.selectedNumber);
      var labelIdFrom = this.normalizeSelectValue(this.selectedLabelIdFrom, true);
      if (dispatchType) q.dispatchType = dispatchType;
      if (variety) q.variety = variety;
      if (batch) q.batch = batch;
      if (number) q.number = String(number);
      if (labelIdFrom) q.labelIdFrom = String(labelIdFrom);
      q.page = String(this.initialPage || 1);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);

      var currentQ = this.$route.query || {};
      var keys = Object.keys(q);
      var isSame = keys.length === Object.keys(currentQ).length &&
        keys.every(function(k) { return String(q[k]) === String(currentQ[k]); });
      if (isSame) return;
      this.$router.replace({ query: q }).catch(function() {});
    },

    },
  };
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Remove bold from filter labels */
.filters-row /deep/ .el-form-item__label,
.filters-row /deep/ label {
  font-weight: normal !important;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Table container with minimum height to prevent loading overlay jump */
.table-container {
  min-height: 400px;
  position: relative;
}

/* Pagination + results inline, right-aligned */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266; /* match label color */
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266; /* match label color */
  font-weight: 500;
}
</style>
